import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NavigationStart, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { EAuditLandingPageService } from '../services/eAudit-landing-page.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { catchError, of, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ChangeDetectorRef } from '@angular/core';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-eaudit-landing-page',
  templateUrl: './eaudit-landing-page.component.html',
  styleUrls: ['./eaudit-landing-page.component.scss'],
})
export class EauditLandingPageComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  recaptchaSiteKey = environment.siteKey;
  errorSubmitMsg: string;
  spinner1: string = 'sp3';
  reCAPTCHAVisible: boolean = false;
  reCAPTCHAToken: string = '';
  recaptchaError: boolean = false;
  captchaError: boolean;
  errorMessage:string= '';
  isAuthFailed: boolean =false;
  
 


  constructor(
    private readonly formBuilder: FormBuilder,
    public router: Router,
    private readonly recaptchaV3Service: ReCaptchaV3Service,
    public eAuditService: EAuditLandingPageService,
    private readonly spinner: NgxSpinnerService,
    private readonly authservice: AuthService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly locationStrategy: LocationStrategy
  ) {
    this.errorSubmitMsg = '';
this.authservice.setBackClicked(false);
// push current state again to prevent further attempts.
history.pushState(null, null, location.href);

router.events
.subscribe((event: NavigationStart) => {
  if (event.navigationTrigger === 'popstate') {
    console.log('curreent eve', event)
    if (event.url === "/docintake/eAudit") {
      this.authservice.setBackClicked(false);
      history.pushState(null, null, location.href);
    }
  }
});

  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      erNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('[0-9]{7}'),
          Validators.minLength(7),
          Validators.maxLength(7),
        ],
      ],
      caseId: ['', [Validators.required, Validators.pattern('[0-9]{16}')]],
    });


    this.generateRecaptchaToken();
    this.checkAuthStatus();

    
  }

  checkAuthStatus() {
    this.authservice.isAuthFailed().subscribe((failed) => {
      this.isAuthFailed = failed;
      if(this.isAuthFailed) {
        this.errorSubmitMsg = 'The system is currently unavailable. Please try again later.'
        this.form.disable();
      } else {
       this.form.enable();
      }
      this.cdRef.detectChanges();
      })
  }

  generateRecaptchaToken() {
    this.recaptchaV3Service.execute('importantAction').pipe(
      tap((token) => {
        this.reCAPTCHAToken = token;
        this.recaptchaError = false;
      }),
      catchError((error) => {
        console.error('reCAPTCHA error:', error);
        this.handleRecaptchaError(error);
        return of(null);
      })
    ).subscribe();
   }
   // Handle reCAPTCHA errors
   handleRecaptchaError(error: any) {
    console.error('reCAPTCHA error:', error);
      this.errorSubmitMsg = "The system is currently unavailable. Please try again later.";
       this.recaptchaError = true;
   }
  
 
  allowNumbers(e: any) {
    return (
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      e.keyCode === 13 ||
      e.keyCode === 46 ||
      e.keyCode === 37 ||
      e.keyCode === 39 ||
      (e.keyCode >= 96 && e.keyCode <= 105) ||
      (e.keyCode >= 48 && e.keyCode <= 90) ||
      (e.keyCode == 65 && e.ctrlKey === true) ||
      (e.keyCode == 67 && e.ctrlKey === true) ||
      (e.keyCode == 88 && e.ctrlKey === true)
    );
  }
  onRightClick(event: { preventDefault: () => void }) {
    event.preventDefault(); //this will disable default action of the context menu
  }

  get f(): { [key: string]: AbstractControl } {
    console.log('test', this.form.controls);
    return this.form.controls;
  }

 

  onSubmit(): void {
    this.errorSubmitMsg = '';
    this.submitted = true;
    this.forceValidation();

    if (this.form.invalid) {
      return;
    }


    this.spinner.show();
    this.checkAuthStatus();
    this.eAuditService.validateERCaseID(this.form.value).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res?.response && res?.response?.opOutput === 'OPFAILED') {
          console.log('res', res);
          let errorOutput = res.response.respErrors.errors[0].output;
          console.log('error outpir', errorOutput);
          if (errorOutput == 'VALIDATION_FAILED_NO_RECORD') {
            this.errorSubmitMsg =
              'Your login was not accepted. Please verify the ER Number or Case ID.';
          }
          else if (errorOutput == 'VALIDATION_FAILED_ARCHIVED') {
            this.errorSubmitMsg =
              'Validation failed, the information provided is no longer available.';
          } 
          else if (errorOutput == 'VALIDATION_FAILED_EXPIRED') {
            this.errorSubmitMsg =
              'Please verify ER Number and Case ID.';
          } 
          
          else {
            let errorMessage = res.response.respErrors.errors[0].message;
            this.errorSubmitMsg = errorMessage;
          }
         } else if (res && res.response && res.response.opOutput === 'OPSUCCESS') {
            window.sessionStorage['ilogged'] = 'ilogged';
            window.sessionStorage['caseid'] = this.form.get('caseId')?.value;
            window.sessionStorage['erNumber'] = this.form.get('erNumber')?.value;

            let docUploaded = res.response.customerConfigDetails?.docUploaded;
            sessionStorage.setItem('docUpload', docUploaded);
            console.log("stored docupload:", docUploaded);

            let totalFilesUploaded = res.response.customerConfigDetails?.totalFilesUploaded 
            ? res.response.customerConfigDetails?.totalFilesUploaded : 0;
            sessionStorage.setItem('totalFilesUploaded', totalFilesUploaded);
            
            


          let addressObject = res.response.customerConfigDetails?.addressJson;

          if (addressObject) {
            try {
              let parsedAddress = JSON.parse(addressObject);
              sessionStorage.setItem('addressJson', JSON.stringify(parsedAddress));
            } catch (error) {
              console.error ("failed to parsed addressJson", error);
            }
            } else {
              console.error ("addressJson is missing in the response");
            }

            let isAddrManuallyUpdate = res.response.customerConfigDetails?.isAddrManuallyUpdate;
            sessionStorage.setItem('isAddrManuallyUpdate', isAddrManuallyUpdate);

            let principalOfficerDetails = res.response.customerConfigDetails?.principalOfficerDetails;
            if(principalOfficerDetails) {
              sessionStorage.setItem('principalOfficerDetails', JSON.stringify(principalOfficerDetails));
            } else {
              console.log ("principalOfficerDetails is missing in the response");
            }

            let repDetails = res.response.customerConfigDetails?.repDetails;
            if(repDetails) {
              sessionStorage.setItem('repDetails', JSON.stringify(repDetails));
            } else {
              console.log ("repDetails is missing in the response");
            }
          

         
            //session storage 
            if (res.response.customerConfigDetails && res.response.customerConfigDetails.fileMetadata) {
              let fileSupported = res.response.customerConfigDetails.fileMetadata.fileSupported;
              sessionStorage.setItem('fileSupported', fileSupported); //filetypes
              let maxFileCount = res.response.customerConfigDetails.fileMetadata.maxFileCount;
              sessionStorage.setItem('maxFileCount', maxFileCount); //150
              let perSubmissionCount = res.response.customerConfigDetails.fileMetadata.perSubmissionCount;
              sessionStorage.setItem('perSubmissionCount', perSubmissionCount); //50

              let pastFileSubCount = res.response.customerConfigDetails.fileMetadata.pastFileSubCount;
              sessionStorage.setItem('pastFileSubCount', pastFileSubCount); 

              let maxFileSizeMB = res.response.customerConfigDetails.fileMetadata.maxFileSizeMB;
              sessionStorage.setItem('maxFileSizeMB',maxFileSizeMB); //100mb
              let maxTotalSizeMB = res.response.customerConfigDetails.fileMetadata.maxTotalSizeMB;
              sessionStorage.setItem('maxTotalSizeMB', maxTotalSizeMB); //1400mb
              let maxUploadPerHourMB =res.response.customerConfigDetails.fileMetadata.maxUploadPerHourMB;
              sessionStorage.setItem('maxUploadPerHourMB', maxUploadPerHourMB); 
              let perUploadMaxLargeFileCnt =res.response.customerConfigDetails.fileMetadata.perUploadMaxLargeFileCnt;
              sessionStorage.setItem('perUploadMaxLargeFileCnt', perUploadMaxLargeFileCnt); //1
              let perUploadMaxLargeSizeMB =res.response.customerConfigDetails.fileMetadata.perUploadMaxLargeSizeMB;
              sessionStorage.setItem('perUploadMaxLargeSizeMB', perUploadMaxLargeSizeMB); //21-100 mb
              let perUploadmaxLargeFileTotalSizeMB =res.response.customerConfigDetails.fileMetadata.perUploadmaxLargeFileTotalSizeMB;
              sessionStorage.setItem('perUploadmaxLargeFileTotalSizeMB', perUploadmaxLargeFileTotalSizeMB); //500
              let perUploadMaxSmallFileCnt =res.response.customerConfigDetails.fileMetadata.perUploadMaxSmallFileCnt;
              sessionStorage.setItem('perUploadMaxSmallFileCnt', perUploadMaxSmallFileCnt); //45
              let perUploadMaxSmallFileSizeMB =res.response.customerConfigDetails.fileMetadata.perUploadMaxSmallFileSizeMB;
              sessionStorage.setItem('perUploadMaxSmallFileSizeMB', perUploadMaxSmallFileSizeMB); // 20 or less
              let perUploadMaxSmallFileTotalSizeMB =res.response.customerConfigDetails.fileMetadata.perUploadMaxSmallFileTotalSizeMB;
              sessionStorage.setItem('perUploadMaxSmallFileTotalSizeMB', perUploadMaxSmallFileTotalSizeMB); //900
              let perUploadMaxFileCount =res.response.customerConfigDetails.fileMetadata.perUploadMaxFileCount; // 10 files per upload
              sessionStorage.setItem('perUploadMaxFileCount', perUploadMaxFileCount);
        
            }


            this.router.navigate(['docintake/eAuditemployerform']);
          } else {
            this.spinner.hide();
            this.errorSubmitMsg =
              'The system is currently unavailable.  Please try again later.';
          }
      },
      (err) => {
        console.log('errrr', err);
        this.spinner.hide();
         if (err.status === 401 || err.status === 0 ) {
          this.errorSubmitMsg =
          'The system is currently unavailable.  Please try again later.';
          this.authservice.logout();
         } else {
         this.errorSubmitMsg =
          'The system is currently unavailable.  Please try again later.';
         }
      }
    );
  }

  onReset(): void {
    this.form.reset();
  }

  forceValidation(): void {
    for (const formField in this.form.controls) {
      const control = this.form.get(formField);

      control?.markAsDirty();
      control?.markAsTouched();
      control?.updateValueAndValidity();
    }
  }

  get caseId() {
    return this.form.get('caseId')!;
  }
  get erNumber() {
    return this.form.get('erNumber')!;
  }
}
